"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
const language_1 = require("./language");
const ERROR_STR = '[ERROR STR]';
/**
 * @hidden
 * t function for solving the internationalization scheme of the widget.
 *
 * @param string String object.
 * @returns String
 *
 * ## Example
 * ``` js
 * import { t } from '@apitable/widget-sdk';
 *
 * const strings = {
 *   total: {
 *     en_US: 'Total'
 *   }
 * };
 *
 * // The current system is English, then the console output "Total".
 * console.log(t(strings.total));
 *
 * ```
 */
function t(string) {
    if (!string) {
        return ERROR_STR;
    }
    const lang = (0, language_1.getLanguage)().replace(/-/g, '_');
    const text = lang in string ? string[lang] : string['zh_CN'] || ERROR_STR;
    return text;
}
exports.t = t;
